import request from '@/utils/request'
import axios from 'axios'
const ajax = {
  // 需方首页商品搜索商品编号
  AllIndexStock(params = {}) {
    // let params = {
    //   'queryStockName': jsonStr
    // }

    console.log('触发')
    params = encodeURIComponent(JSON.stringify(params))
    return request.post('/mall/mallmanage/index/queryAllIndexStock?jsonStr=' + params)
  },
  // 需方首页商品搜索根据供方商品IDs获取获取商品信息
  StockInformation(ids = '', obj, mids) {
    let params = {
      'providerStockFIDs': ids,
      'mallstorestockFIDs': mids,
      ...obj
    }
    params = encodeURIComponent(JSON.stringify(params))
    return request.post('/mall/mallmanage/index/queryAllIndexStockInformation?jsonStr=' + params)
  },
  // 需方首页商品搜索根据供方商品IDs及辅助筛选条件获取获取商品信息
  StockInformationFilter(params = {}) {
    params = encodeURIComponent(JSON.stringify(params))
    console.log('触发')
    return request.post('/mall/mallmanage/index/queryAllIndexStock?jsonStr=' + params)
  },
  // 根据搜索返回的品牌id查询对应品牌名； 需方首页商品搜索根据品牌IDs获取检索品牌
  MakeRequest(ids = '') {
    const params = {
      'markFIDs': ids
    }
    // params = JSON.stringify(params)
    return request.post('/mall/mallmanage/index/queryAllIndexStockMark', params)
  },
  // 根据搜索返回的商品id查询对应规格参数；
  PropWithRequest(ids = '') {
    let params = {
      'providerStockFIDs': ids
    }
    params = encodeURIComponent(JSON.stringify(params))
    return request.post('/mall/mallmanage/index/queryAllIndexStockPropWithValue?jsonStr=' + params)
  },
  // 需方首页商品搜索根据标准类别IDs获取检索标准类别
  StockStdStockClass(ids = '') {
    const params = {
      'stdStockClassFIDs': ids
    }
    // params = encodeURIComponent(JSON.stringify(params))
    const nParams = new URLSearchParams()
    nParams.append('jsonStr', JSON.stringify(params))
    return request.post('/mall/mallmanage/index/queryAllIndexStockStdStockClass', nParams)
  }
}

export default ajax
